<template>
  <right-menu-item
    v-if="show"
    @click.prevent="click"
    :text="$t('New document')"
    :loading="loading"
    icon="document-add"
  />
</template>

<script>
import AddDocument from '@/frontapp/mixins/AddDocument'
import { mapStores } from 'pinia'
import useBcFolderStore from '@/frontapp/store/bcFolder'

export default {
  mixins: [AddDocument],
  computed: {
    show () {
      return this.bcFolderStore.current?.can_edit
    },
    ...mapStores(useBcFolderStore),
  },
  methods: {
    click() {
      this.addDocument()
    }
  },
}
</script>

<style lang="scss" scoped></style>
